<template>
  <div class="index">
    <div class="index-con">
      <!-- <img class="index-img" src="@/assets/images/new-018.jpg" alt="" /> -->
      <div class="router">
        <span>IRADSTM</span> <b>→</b> <span>关于IRADSTM</span> <b>→</b>
        <span>IRADSTM介绍</span>
      </div>
      <div class="box-title-big">
        介绍
      </div>
      <div class="title"> 国际干燥科学与技术研究会</div>
      <div class="box-title"></div>
      <div class="box">
        <div class="left">

          <div class="text">
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;国际干燥科学与技术研究会（IRADSTM）于2024年6月在澳门成功注册，成为一个干燥科学与技术领域正式注册的国际学术组织。
            <br /><br />
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;IRADSTM是由全球干燥及相关学科的专家自愿组成的专业性、学术性、非营利性组织。
            <br /><br />
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;IRADSTM的宗旨是促进干燥高效节能与绿色发展，促进干燥科学的普及与先进技术的推广应用，促进干燥科技人才的培养，推动国际干燥科技事业健康、稳定、可持续地发展。
            <br />
          </div>
        </div>
        <div class="right">
          <img src="@/assets/images/new-004.png" alt="" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {

    }
  },
  mounted() {
    this.getTitle();
  },
  methods: {
    getTitle() {
      //document.title = "IRADSTM | IRADSTM介绍";
    }
  }
};
</script>

<style lang="less" scoped>
.index-con {
  width: 1200px;
  margin: 0 auto;
  padding-bottom: 50px;

  .text {
    font-size: 16px;
    line-height: 2;
  }

  .title {
    font-size: 24px;
    color: #5b965a;
    margin-bottom: 10px;
    font-weight: 700;
    font-family: Canaro, Arial, sans-serif;
    text-align: center;
  }


  .box-title-big {
    position: relative;
    padding-bottom: 10px;
    color: #5b965a;
    font-family: Canaro, Arial, sans-serif;
    font-size: 30px;
    line-height: 1.9;
    font-weight: 700;
    margin-bottom: 20px;
    text-align: center;

    &::before {
      content: "";
      position: absolute;
      bottom: 0;
      left: 50%;
      transform: translateX(-50%);
      width: 20%;
      max-width: 100%;
      height: 6px;
      background-color: #5b965a;

    }
  }

  .box-title {
    position: relative;
    padding-bottom: 10px;
    color: #5b965a;
    font-family: Canaro, Arial, sans-serif;
    font-size: 30px;
    line-height: 1.9;
    font-weight: 700;
    margin-bottom: 30px;
    text-align: center;

  }

  .box {
    display: flex;
    padding-right: 100px;
    box-sizing: border-box;
    //align-items: center;

    .left {
      flex: 1;
    }

    .right {
      padding: 40px 0;
      flex-shrink: 0;
      margin-left: 60px;
      width: 230px;
      border-top: 10px solid #f9b033;
      border-bottom: 10px solid #5b965a;
      display: flex;
      align-items: center;
      justify-content: center;

      img {
        width: 70%;
      }
    }
  }

  .router {
    display: flex;
    margin: 23px 0 31px;
    align-items: center;

    span {
      color: rgba(31, 31, 31, 0.5);
      font-family: Canaro, Arial, sans-serif;
      font-size: 14px;
      line-height: 1.8;
      font-weight: 400;
      white-space: nowrap;
      cursor: pointer;
    }

    b {
      color: #f9b033;
      font-weight: 400;
      margin: 0 10px;
    }

    span:nth-last-of-type(1) {
      color: #333;
    }
  }

  .index-img {
    width: 100%;
    height: auto;
  }
}

@media screen and (max-width: 768px) {
  .index-con {
    width: 100%;
    padding: 0 20px;
    box-sizing: border-box;

    .box-title-big {
      font-size: 20px;
    }

    .title {
      font-size: 18px;
    }

    .box {
      display: block;
      padding-right: 0;

      .left {
        width: 100%;
        margin-bottom: 30px;
      }

      .right {
        width: 100%;
        margin-left: 0;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Introduction.vue